import React from 'react';
import PropTypes from 'prop-types';

import TransparentBackgroundOverlay from './TransparentBackgroundOverlay';
import SubmitAndCancelButtonGroup from './SubmitAndCancelButtonGroup';
import { ErrorMessageDisplay } from './ErrorMessageDisplay';
import { Spinner } from './Spinner';

const ConfirmFormSubmissionPopup = (props) => {
    if (!props.popUpShown) return null;

    return (
        <TransparentBackgroundOverlay
            header={props.header}
            onClose={props.onCancel}
        >
            <div className="m-8">
                <div className="text-lg">{props.renderConfirmationMessage}</div>
                <ErrorMessageDisplay errorMessage={props.errorMessage} />
                <div className="my-5">
                    <Spinner showSpinner={props.submitting} color={'blue'} />
                </div>
                <div className="m-5">
                    <SubmitAndCancelButtonGroup
                        submitButtonText={props.submitButtonText}
                        onCancel={props.onCancel}
                        onSubmit={props.onSubmit}
                        disableSubmit={props.submitting}
                        disableCancel={props.submitting}
                    />
                </div>
            </div>
        </TransparentBackgroundOverlay>
    );
};

ConfirmFormSubmissionPopup.propTypes = {
    popUpShown: PropTypes.bool,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
    errorMessage: PropTypes.string,
    submitting: PropTypes.bool,
    header: PropTypes.string,
    submitButtonText: PropTypes.string,
    renderConfirmationMessage: PropTypes.any,
};

export default ConfirmFormSubmissionPopup;
